"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.estimateEVMDepositJRC20 = exports.estimateEVMWithdrawJRC20 = exports.executeEVMTransaction = exports.estimateEVMOperation = exports.estimateEVMCall = exports.estimateEVMBaseFee = exports.getWalletNonce = void 0;
const chain_1 = require("../../chain");
const utils_1 = require("../../utils");
const operation_1 = require("../operation");
const constants_1 = require("./constants");
const fee_1 = require("./fee");
const transaction_1 = require("./transaction");
async function getWalletNonce(wallet, api, synchronize) {
    if (synchronize || !wallet.synchronized) {
        wallet.synchronized = true;
        // In the future may set unsync if error occurs in sync process.
        // Verify that it would not negatively impact any other logics before.
        // Not doing it now because of doubt it could fail somewhere else.
        wallet.nonce = await api.eth_getTransactionCount(wallet.getAddress(), 'pending');
    }
    return wallet.nonce++;
}
exports.getWalletNonce = getWalletNonce;
async function estimateEVMBaseFee(api) {
    return await api.eth_baseFee().catch(() => {
        return api.chain.baseFee;
    });
}
exports.estimateEVMBaseFee = estimateEVMBaseFee;
async function estimateEVMCall(api, from, to, value, data, baseFee) {
    // in case of native asset transfer return SendEtherLimit
    if (value > BigInt(0) && data === chain_1.EmptyCallData) {
        return chain_1.SendEtherGasLimit;
    }
    const gasLimit = await api.chain.ethProvider.estimateGas({
        blockTag: 'pending',
        from,
        to,
        value,
        // TODO Add it as parameter
        // Warning to not use getWalletNonce() as it increments cached nonce.
        // nonce: Number(nonce),
        chainId: api.chain.chainId,
        gasPrice: baseFee,
        data
    });
    return gasLimit;
}
exports.estimateEVMCall = estimateEVMCall;
async function estimateEVMOperation(provider, chain, from, operation, spendings, values, address, amount, data, feeType) {
    const api = provider.jevmApi[chain.id];
    const baseFee = await estimateEVMBaseFee(api);
    const fee = new fee_1.EVMFeeData(chain, baseFee * BigInt(0), feeType, baseFee, BigInt(0), new transaction_1.EVMTransactionData(from, address, amount, data));
    spendings.push(fee.spending);
    return await estimateEVMCall(api, from, address, amount, data, baseFee).then((gasLimit) => {
        fee.setGasLimit(gasLimit);
        return new operation_1.ChainOperationSummary(provider, operation, chain, fee, spendings, values, []);
    }, (error) => {
        return new operation_1.ChainOperationSummary(provider, operation, chain, fee, spendings, values, [error]);
    });
}
exports.estimateEVMOperation = estimateEVMOperation;
async function executeEVMTransaction(provider, wallet, feeData) {
    const api = provider.jevmApi[wallet.chain.id];
    const unsignedTransaction = {
        from: wallet.getAddress(),
        to: feeData.data.to,
        value: feeData.data.value,
        nonce: Number(await getWalletNonce(wallet, api, false)),
        chainId: api.chain.chainId,
        gasLimit: feeData.gasLimit,
        gasPrice: feeData.baseFee,
        data: feeData.data.data
    };
    for (let i = 0; i < constants_1.MaxInvalidNonceAttempts; i++) {
        const transaction = await wallet.evmWallet.signTransaction(unsignedTransaction);
        const transactionId = await api.eth_sendRawTransaction(transaction).catch((error) => {
            const errorMessage = error.message;
            if (errorMessage.includes('nonce') || errorMessage.includes('replacement transaction underpriced')) {
                return undefined;
            }
            // Non nonce related error decrement nonce to avoid resyncing later.
            wallet.nonce--;
            throw error;
        });
        if (typeof transactionId === 'string') {
            return transactionId;
        }
        await utils_1.TimeUtils.sleep(constants_1.InvalidNonceRetryDelay);
        unsignedTransaction.nonce = Number(await getWalletNonce(wallet, api, true));
    }
    throw new utils_1.TransactionError(`could not provide a valid nonce: ${wallet.nonce}`);
}
exports.executeEVMTransaction = executeEVMTransaction;
async function estimateEVMWithdrawJRC20(api, sender, jrc20, amount) {
    const data = jrc20.adapter.getWithdrawData(amount);
    const baseFee = await estimateEVMBaseFee(api);
    const fee = new fee_1.EVMFeeData(api.chain, baseFee * constants_1.DefaultWithdrawEstimate, transaction_1.TransactionType.Withdraw, baseFee, constants_1.DefaultWithdrawEstimate, new transaction_1.EVMTransactionData(sender, jrc20.address, BigInt(0), data));
    await estimateEVMCall(api, sender, jrc20.address, BigInt(0), data, baseFee).then((gasLimit) => {
        fee.setGasLimit(gasLimit);
    }, () => { });
    return fee;
}
exports.estimateEVMWithdrawJRC20 = estimateEVMWithdrawJRC20;
async function estimateEVMDepositJRC20(api, sender, jrc20, amount) {
    const data = jrc20.adapter.getDepositData(jrc20.nativeAssetId, amount);
    const baseFee = await estimateEVMBaseFee(api);
    const fee = new fee_1.EVMFeeData(api.chain, baseFee * constants_1.DefaultDepositEstimate, transaction_1.TransactionType.Deposit, baseFee, constants_1.DefaultDepositEstimate, new transaction_1.EVMTransactionData(sender, chain_1.NativeAssetCallContract, BigInt(0), data));
    await estimateEVMCall(api, sender, chain_1.NativeAssetCallContract, BigInt(0), data, baseFee).then((gasLimit) => {
        fee.setGasLimit(gasLimit);
    }, () => { });
    return fee;
}
exports.estimateEVMDepositJRC20 = estimateEVMDepositJRC20;
